import Vue from "vue";
import Vuex from "vuex";
import 'vuejs-dialog/dist/vuejs-dialog.min.css';

Vue.use(Vuex);

const state = {
  layout: "home",
  user: JSON.parse(localStorage.getItem("user")),
  token: localStorage.getItem("user-token"),
  isLoading:false
};
const getters = {
  layout: state => state.layout,
  user: state => state.user,
  token: state => state.token,
  isLoading:state=>state.isLoading
};

const mutations = {

  CHANGE_TOKEN(state,token) {
    localStorage.setItem("user-token", token);
  },
  CHANGE_USER(state,user) {
    localStorage.setItem("user", JSON.stringify(user));
  },
  CHANGE_LOADER(state,isLoad)  {
   state.isLoading=isLoad;
  },
  REMOVE_TOKEN(){
    localStorage.removeItem("user");
    localStorage.removeItem("user-token");
    localStorage.removeItem("isKeep");
  }
};
const actions = {

  CHANGE_TOKEN: ({ commit }, token) => {
    commit("CHANGE_TOKEN", token);
  },

  CHANGE_USER: ({ commit }, user) => {
    commit("CHANGE_USER", user);
  },
  CHANGE_LOADER: ({ commit }, isLoad) => {
    commit("CHANGE_LOADER", isLoad);
  },
  REMOVE_TOKEN: ({ commit }) => {
    commit("REMOVE_TOKEN");
  }
};
export default new Vuex.Store({
  state,
  getters,
  actions,
  mutations});
